import React, { useEffect } from 'react';
import { useGlobalHeader } from 'src/hooks/queries/navigation';
import { isMobileApp } from 'src/utils/url.utils';

export default function GlobalHeader(): JSX.Element {
    const { data: globalHeader } = useGlobalHeader();
    const isOnMobileApp = isMobileApp();

    useEffect(() => {
        if (globalHeader && !isOnMobileApp) {
            const secondaryNav: HTMLElement = document.getElementById('secondaryNav');
            if (secondaryNav) secondaryNav.style.top = '61px';
        }
    }, [globalHeader, isOnMobileApp]);

    if (!globalHeader || isOnMobileApp) return null;

    return <div dangerouslySetInnerHTML={{ __html: globalHeader }} />;
}
